import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row, Card, CardBody, CardHeader } from 'reactstrap';
import BigCalendar from './components/BigCalendar/BigCalendar';
import { RTLProps } from '../../shared/prop-types/ReducerProps';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faEyeSlash, faNoteSticky, faTrash } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import ModalCalendarNotes from './components/CalendarNotes/ModalCalendarNotes';
import AlertModal from '../../shared/components/Modal';

const ExamplePage = ({ rtl }) => {

  const [dateSelected, setDateSelected] = useState(null);
  const [notes, setNotes] = useState([]);
  const [notesVisible, setNotesVisible] = useState(false);
  const [notesLoading, setNotesLoading] = useState(false);
  const [disabledButtonShow, setDisabledButtonShow] = useState(true);
  const [openModalNotes, setOpenModalNotes] = useState(false);
  const [noteDelete, setNoteDelete] = useState(null);

  const [showAlertModal, setAlerShowModal] = useState(false);
  const [messagAlerteModal, setAlertMessageModal] = useState(null);
  const [colorAlertModal, setAlertColorModal] = useState("");

  const updateDateSelected = async (date) => {
    setDateSelected(date);
    getNotesFromDate(date);
  }

  const getNotesFromDate = async (dateCalendar) => {
    setNotesLoading(true);
    if (dateCalendar != null && dateCalendar != undefined) {
      await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda-notas/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          fecha_inicial: moment(`${moment(dateCalendar).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
          fecha_final: moment(`${moment(dateCalendar).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss')
        })
      }).then(response => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        }
        else {
          throw new Error('Data');
        }
      }).then(dataResponse => {
        if (dataResponse.length > 0) {
          setNotes(dataResponse);
          setNotesVisible(true);
          setDisabledButtonShow(false);
        }
        else {
          setNotes([]);
          setNotesVisible(false);
          setDisabledButtonShow(true);
        }
        setNotesLoading(false);
      }).catch(err => {
        setNotes([]);
        setNotesLoading(false);
        setDisabledButtonShow(true);
        console.log(err);
      });
    }
    else {
      setNotesLoading(false);
      setNotes([]);
    }
  }

  const deleteNote = async (item) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda-notas/delete', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify({
        id_nota_agenda: item.id_nota_agenda
      })
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        setAlertMessageModal("Nota Eliminada exitosamente");
        setAlertColorModal("success");
        setAlerShowModal(true);
        setNoteDelete(null);
      }
      else {
        throw new Error('Data');
      }
    }).catch(err => {
        setAlertMessageModal("Ha ocurrido un error eliminando la Nota");
        setAlertColorModal("danger");
        setAlerShowModal(true);
        setNoteDelete(null);
      console.log(err);
    });
  }

  const onOkModalNote = async () => {
    switch (colorAlertModal) {
      case "success":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        setNoteDelete(null);
        await getNotesFromDate(dateSelected);
        break;
      case "warning":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        await deleteNote(noteDelete);
        break;
      case "danger":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        setNoteDelete(null);
        break;
    }
  }

  const onToggleModalNote = async () => {
    switch (colorAlertModal) {
      case "success":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        setNoteDelete(null);
        await getNotesFromDate(dateSelected);
        break;
      case "warning":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        setNoteDelete(null);
        break;
      case "danger":
        setAlerShowModal(false);
        setAlertMessageModal("");
        setAlertColorModal("");
        setNoteDelete(null);
        break;
    }
  }

  return (<Container>
    <Row>
      <Col md={1}>
        <div className='text-center'>
          <div id="divButtonsNotes">
            <Tooltip title="Agregar Nota del Dia">
              <IconButton aria-label="upload picture" component="span" style={{ 
                fontSize: 15, 
                padding: 9, 
                backgroundColor: dateSelected == null || dateSelected == undefined ? "#C4D0CD" : '#55e5bb' 
              }}
                className='tooltip-top'
                disabled={dateSelected == null || dateSelected == undefined ? true : false}
                onClick={() => {
                  setOpenModalNotes(true);
                }}>
                <FontAwesomeIcon icon={faPlus} style={{ color: '#153365' }} />
              </IconButton>
            </Tooltip>
            <span>&nbsp;&nbsp;</span>

            {
              notesVisible == true ? <Tooltip title="Ocultar Notas del Dia">
                <IconButton aria-label="upload picture" component="span" style={{ fontSize: 15, padding: 9, backgroundColor: '#55e5bb' }}
                  className='tooltip-top'
                  onClick={() => {
                    setNotesVisible(false);
                  }}>
                  <FontAwesomeIcon icon={faEyeSlash} style={{ color: '#153365' }} />
                </IconButton>
              </Tooltip> : <Tooltip title="Visualizar Notas del Dia">
                <IconButton aria-label="upload picture" component="span" style={{
                  fontSize: 15,
                  padding: 9,
                  backgroundColor: disabledButtonShow == true ? '#C4D0CD' : '#55e5bb'
                }}
                  className='tooltip-top'
                  disabled={disabledButtonShow}
                  onClick={() => {
                    setNotesVisible(true);
                  }}>
                  <FontAwesomeIcon icon={faNoteSticky} style={{ color: '#153365' }} />
                </IconButton>
              </Tooltip>
            }

          </div>
          <h3 className="page-title">Agenda</h3>
        </div>
      </Col>
      <Col md={11}>
        {
          notesLoading == true ? <div className='text-center'>
            <Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" />
          </div> :
            <Row>
              {
                notesVisible == true ? <>
                  {notes.map((item, index) => (
                    <Col md={3}>
                      <Card>
                        <CardBody style={{ maxHeight: 75, overflowY: 'scroll', overflowX: 'hidden', padding: 12, marginTop: -25 }}>
                          <Row>
                            <Col md={10}>
                              {
                                /*
                              <label><b>Asunto:&nbsp;</b>{item.titulo.toUpperCase()}</label>
                              <br />
                              <label><b>Autor:&nbsp;</b>{item.nombre_usuario.toUpperCase()}</label>
                                 */
                              }
                              <p>
                                {item.nota}
                              </p>
                            </Col>
                            <Col md={2}>
                              <Tooltip title="Eliminar Nota">
                                <IconButton aria-label="upload picture" className="bg-danger tooltip-top" component="span" style={{ fontSize: 14, padding: 3, marginLeft: 10 }}
                                  onClick={() => {
                                    setAlertMessageModal("Esta seguro que desea eliminar esta nota?");
                                    setAlertColorModal("warning");
                                    setAlerShowModal(true);
                                    setNoteDelete(item);
                                  }}>
                                  <FontAwesomeIcon icon={faTrash} className="text-white" />
                                </IconButton>
                              </Tooltip>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      <br/><br/>
                    </Col>)
                  )}
                </> : null
              }
            </Row>
        }
      </Col>
    </Row>

    {
      openModalNotes == true ?
        <ModalCalendarNotes
          dateCalendar={dateSelected}
          closeModal={() => setOpenModalNotes(false)}
          opened={openModalNotes}
          Callback={() => getNotesFromDate(dateSelected)}
        /> : null
    }

    <AlertModal
      color={colorAlertModal}
      title={messagAlerteModal}
      modal={showAlertModal}
      onOk={() => onOkModalNote()}
      toggle={() => onToggleModalNote()}
    />

    <BigCalendar dir={rtl.direction} setDateSelected={(date) => updateDateSelected(date)} />
  </Container>);
};

ExamplePage.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(ExamplePage);
